module.exports = __webpack_public_path__ + "media/npc_dota_hero_winter_wyvern.794b6d79.webm";